import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DocViewerComponent,
} from '@commenda/kakashi';

interface FilePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string;
  title?: string;
}

const FilePreviewModal = ({
  isOpen,
  onClose,
  fileUrl,
  title = 'Certificate',
}: FilePreviewModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="min-w-[70vw] p-0 flex flex-col overflow-hidden h-full"
        preventCloseOnOutsideClick
        hideCloseIcon
      >
        <DialogHeader>
          <DialogTitle>{title || 'Certificate'}</DialogTitle>
        </DialogHeader>
        <div className="p-6 flex flex-col overflow-y-auto flex-1 h-full">
          <DocViewerComponent uri={fileUrl} />
        </div>
        <DialogFooter>
          <Button size="sm" onClick={onClose} type="button">
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FilePreviewModal;
